import { render, staticRenderFns } from "./DetailsClientView.vue?vue&type=template&id=59094e4e&scoped=true"
import script from "./DetailsClientView.vue?vue&type=script&lang=ts"
export * from "./DetailsClientView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59094e4e",
  null
  
)

export default component.exports